// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2zHDP","vLegacy":"SelectSecondary_vLegacy__15vsa","error":"SelectSecondary_error__1MtjP","disabled":"SelectSecondary_disabled__2YZWi"};